import styled from 'styled-components';
import WBIcon from './elements/WBIcon';

export const EllipsesMenuButton = styled(WBIcon)`
  font-size: 24px;
  margin-left: 4px;
  cursor: pointer;
  align-items: center;
`;
